import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApplicationService } from '../services/application.service'
import { Router, ActivatedRoute } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { Observable } from 'rxjs/Observable';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  statusMessage: string = "Loading data please wait...";

  adminPharmacyOrderSummeryAllList: [];
  adminPharmacyOrderSummeryPendingList: [];
  adminPharmacyOrderSummeryCompletedList: [];

  adminLaboratoryOrderSummeryAllList: [];
  adminLaboratoryOrderSummeryPendingList: [];
  adminLaboratoryOrderSummeryCompletedList: [];

  adminDiagnosticOrderSummeryAllList: [];
  adminDiagnosticOrderSummeryPendingList: [];
  adminDiagnosticOrderSummeryCompletedList: [];

  adminRefferalOrderSummeryAllList: [];
  adminRefferalOrderSummeryPendingList: [];
  adminRefferalOrderSummeryCompletedList: [];

  isLoginByAdmin: boolean = false;
  partnerTypeId: string = '';
  orderItemList: any[];
  orderPendingList: any[];
  orderCompletedItemList: any[];

 


  constructor(private _applicationService: ApplicationService, private router: Router, private _partnerService: PartnerService, private cdRef: ChangeDetectorRef) {
    this.isLoginByAdmin = _applicationService.loginUserDetails.isAdmin
    this.partnerTypeId = _applicationService.loginUserDetails.partnertypeId
    console.log('this.isLoginByAdmin: ' + this.isLoginByAdmin)
  }

  ngOnInit() {
    if (this.isLoginByAdmin) {
      this.getadminOrderSummery();
    }
    else{
      this.getPartnerOrderSummery();
    }
   
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  getadminOrderSummery() {
    this._partnerService.getAdminOrderSummery()
      .subscribe(
        (employeeData) => {
          console.log(employeeData)
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.adminPharmacyOrderSummeryAllList = employeeData.response.pharmacyOrder.AllItems;
            this.adminPharmacyOrderSummeryPendingList = employeeData.response.pharmacyOrder.pendingItems;
            this.adminPharmacyOrderSummeryCompletedList = employeeData.response.pharmacyOrder.deliveredItems;

            this.adminLaboratoryOrderSummeryAllList = employeeData.response.laboratoryOrder.AllItems;
            this.adminLaboratoryOrderSummeryPendingList = employeeData.response.laboratoryOrder.pendingItems;
            this.adminLaboratoryOrderSummeryCompletedList = employeeData.response.laboratoryOrder.deliveredItems;

            this.adminDiagnosticOrderSummeryAllList = employeeData.response.diagnosticOrder.AllItems;
            this.adminDiagnosticOrderSummeryPendingList = employeeData.response.diagnosticOrder.pendingItems;
            this.adminDiagnosticOrderSummeryCompletedList = employeeData.response.diagnosticOrder.deliveredItems;

            this.adminRefferalOrderSummeryAllList = employeeData.response.refferalOrder.AllItems;
            this.adminRefferalOrderSummeryPendingList = employeeData.response.refferalOrder.pendingItems;
            this.adminRefferalOrderSummeryCompletedList = employeeData.response.refferalOrder.deliveredItems;


          }

        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  getPartnerOrderSummery() {
    debugger
    if (this.partnerTypeId == '1') {
      this._partnerService.getLaboratoryOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order; 
            this.orderPendingList = employeeData.response.order.filter(s => s.isOrderdelivered == false ||  s.isOrderdelivered == 'false')
            this.orderCompletedItemList = employeeData.response.order.filter(s => s.isOrderdelivered);
          }         
         console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
 
      );
    }

    if (this.partnerTypeId == '2') {
      this._partnerService.getDiagnosticsOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order; 
            this.orderPendingList = employeeData.response.order.filter(s => s.isOrderdelivered == false ||  s.isOrderdelivered == 'false')
            this.orderCompletedItemList = employeeData.response.order.filter(s => s.isOrderdelivered);          
          }         
        console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
 
      );
    }

    if (this.partnerTypeId == '3') {
      this._partnerService.getPharmacyOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order; 
            this.orderPendingList = employeeData.response.order.filter(s => s.isOrderdelivered == false ||  s.isOrderdelivered == 'false')
            this.orderCompletedItemList = employeeData.response.order.filter(s => s.isOrderdelivered);           
          }         
        console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
 
      );
    }

    if (this.partnerTypeId == '4') {
      this._partnerService.getReferralOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order; 
            this.orderPendingList = employeeData.response.order.filter(s => s.isOrderdelivered == false ||  s.isOrderdelivered == 'false')
            this.orderCompletedItemList = employeeData.response.order.filter(s => s.isOrderdelivered);           
          }         
        console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
 
      );
    }

  }

 

}
